import React from "react";

function SentIcon() {
  return (
    <span className="anticon ant-sent">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 19 17"
      >
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M.193 15.118c-.282 1.02.276 1.504 1.252 1.081l16.536-7.173c.974-.423.976-1.106 0-1.53L1.445.323C.471-.099-.089.386.193 1.403l1.556 5.62 10.876 1.238L1.749 9.499l-1.556 5.62z"
        ></path>
      </svg>
    </span>
  );
}

export default SentIcon;
